import { OverviewImageLinkPoint } from './OverviewImageModal.types';

export const DEFAULT_OVERVIEW_IMAGE_LINK_POINTS: OverviewImageLinkPoint[] = [];
